import MonitoraggioPressioneEdit from "./components/MonitoraggioPressioneEdit.vue";
import MonitoraggioPressioneView from "./components/MonitoraggioPressioneView.vue";
import MonitoraggioPressioneList from "./components/MonitoraggioPressioneList.vue";

export default {
    MonitoraggioPressioneEdit,
    MonitoraggioPressioneView,
    MonitoraggioPressioneList,
};
